import { loadStripe } from "@stripe/stripe-js/pure";
const stripePromises = new Map();
const getOwnerStripe = () => {
  // Beauti billing uses the platform account. Salon customer payments use
  // getStripeClient separately.
  const stripe_publishable_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
  const usableStripeKey = /^pk_(test|live)_[A-Za-z0-9]{24,}$/.test(stripe_publishable_key);
  if (!usableStripeKey) return null;
  if (!stripePromises.has(stripe_publishable_key)) {
    stripePromises.set(stripe_publishable_key, loadStripe(stripe_publishable_key));
  }
  return stripePromises.get(stripe_publishable_key);
};

export default getOwnerStripe;
